<template>
  <div class="container">
    <div class="title">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>平台建设</el-breadcrumb-item>
        <el-breadcrumb-item>基础信息</el-breadcrumb-item>
        <el-breadcrumb-item>资源信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="title-en">1.园区及机房(在维)</div>
    <el-card class="box-card">
      <el-table
        :data="datacenterData"
        style="width: 100%"
        :header-cell-style="headerStyle"
        :row-class-name="tableRowClassName"
      >
        <el-table-column prop="region" label="地区" align="center" width="100"></el-table-column>
        <el-table-column
          prop="province"
          label="省/直辖市"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column prop="area" label="区域/园区" align="center" width="120"></el-table-column>
        <el-table-column prop="type" label="机房类型" align="center" width="100">
          <template slot-scope="scope">
            <span style="color: #219aff">{{ scope.row.type }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="一级机房名称" align="center"></el-table-column>
        <el-table-column prop="startDate" label="起始日期" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" align="center" width="80"></el-table-column>
      </el-table>
    </el-card>

    <div class="title-en">2.值班账号</div>
    <el-card class="box-card">
      <el-table
        :data="dutyAccountData"
        style="width: 100%"
        :header-cell-style="headerStyle"
        :row-class-name="tableRowClassName"
      >
        <el-table-column prop="region" label="地区" align="center" width="100"></el-table-column>
        <el-table-column
          prop="province"
          label="省/直辖市"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column prop="area" label="区域/园区" align="center" width="120"></el-table-column>
        <el-table-column prop="accountName" label="值班账号名称" align="center"></el-table-column>
        <el-table-column prop="phone" label="值班账号联系电话" align="center"></el-table-column>
        <el-table-column prop="owner" label="电话所属人员姓名" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" align="center" width="80"></el-table-column>
      </el-table>
    </el-card>

    <div class="title-en">3.岗位与标签</div>
    <el-card class="box-card">
      <el-table
        :data="positionTagData"
        style="width: 100%"
        :header-cell-style="headerStyle"
        :row-class-name="tableRowClassName"
      >
        <el-table-column prop="project" label="项目" align="center" width="100"></el-table-column>
        <el-table-column prop="type1" label="类型1" align="center"></el-table-column>
        <el-table-column prop="type2" label="类型2" align="center"></el-table-column>
        <el-table-column prop="type3" label="类型3" align="center"></el-table-column>
        <el-table-column prop="type4" label="类型4" align="center"></el-table-column>
        <el-table-column prop="type5" label="类型5" align="center"></el-table-column>
        <el-table-column prop="type6" label="类型6" align="center"></el-table-column>
        <el-table-column prop="type7" label="类型7" align="center"></el-table-column>
        <el-table-column prop="type8" label="类型8" align="center"></el-table-column>
        <el-table-column prop="type9" label="类型9" align="center"></el-table-column>
        <el-table-column prop="type10" label="类型10" align="center"></el-table-column>
      </el-table>
    </el-card>

    <div class="title-en">4.合作单位(外部)</div>
    <el-card class="box-card">
      <resource-table
        :header-style="headerStyle"
        @edit="handleEdit"
        @delete="handleDelete"
        @history="handleHistory"
      />
    </el-card>
  </div>
</template>
  
  <script>
import ResourceTable from './components/ResourceTable.vue';

export default {
  components: {
    ResourceTable,
  },
  data() {
    return {
      headerStyle: {
        background: '#F5F7FA',
        color: '#303133',
        fontWeight: 'bold',
        textAlign: 'center',
      },
      datacenterData: [
        {
          region: '华东',
          province: '上海',
          area: '上海-临港',
          type: 'DC',
          name: '上海移动临港DC',
          startDate: '',
          status: '在维',
        },
        {
          region: '华东',
          province: '上海',
          area: '上海-书院',
          type: 'DC',
          name: '上海移动书院DC',
          startDate: '',
          status: '在维',
        },
        {
          region: '华东',
          province: '浙江',
          area: '杭州-东冠',
          type: 'EC',
          name: '杭州电信东冠EC',
          startDate: '',
          status: '在维',
        },
        {
          region: '华东',
          province: '浙江',
          area: '杭州-通普',
          type: 'EC',
          name: '杭州联通通普EC',
          startDate: '',
          status: '在维',
        },
        {
          region: '华东',
          province: '浙江',
          area: '杭州-1枢纽',
          type: 'EC',
          name: '杭州联通-枢纽EC',
          startDate: '',
          status: '在维',
        },
        {
          region: '华东',
          province: '浙江',
          area: '杭州-萧山',
          type: 'EC',
          name: '杭州移动萧山EC',
          startDate: '',
          status: '在维',
        },
        {
          region: '华南',
          province: '广东',
          area: '清远-清新',
          type: 'DC',
          name: '清远腾讯清新DC',
          startDate: '',
          status: '在维',
        },
        {
          region: '华北',
          province: '河北',
          area: '怀来-东园',
          type: 'DC',
          name: '张家口腾讯怀来东园DC',
          startDate: '',
          status: '在维',
        },
      ],
      positionTagData: [
        {
          project: '运维岗位',
          type1: 'IT运维',
          type2: 'IT现场运维管理岗',
          type3: 'FRE运营开发岗',
          type4: '综合支持岗',
          type5: '',
          type6: '',
          type7: '',
          type8: '',
          type9: '',
          type10: '',
        },
        {
          project: '岗位职责',
          type1: '网络',
          type2: '服务器',
          type3: '资产',
          type4: '',
          type5: '',
          type6: '',
          type7: '',
          type8: '',
          type9: '',
          type10: '',
        },
        {
          project: '岗位性质',
          type1: '5*8小时',
          type2: '7*24小时',
          type3: '',
          type4: '',
          type5: '',
          type6: '',
          type7: '',
          type8: '',
          type9: '',
          type10: '',
        },
        {
          project: '岗位级别',
          type1: '初级',
          type2: '中级',
          type3: '高级',
          type4: '',
          type5: '',
          type6: '',
          type7: '',
          type8: '',
          type9: '',
          type10: '',
        },
        {
          project: '技能标签',
          type1: '网络复杂',
          type2: '服务器专项',
          type3: '资源交付',
          type4: '特殊变更',
          type5: '数据相关',
          type6: '改造',
          type7: '资产',
          type8: '',
          type9: '',
          type10: '',
        },
        {
          project: '人员类别',
          type1: '计费HC',
          type2: '专职专项(资源池白名单)',
          type3: '合作专项(外部白名单)',
          type4: '',
          type5: '',
          type6: '',
          type7: '',
          type8: '',
          type9: '',
          type10: '',
        },
        {
          project: '状态信息',
          type1: '在职',
          type2: '离职',
          type3: '',
          type4: '',
          type5: '',
          type6: '',
          type7: '',
          type8: '',
          type9: '',
          type10: '',
        },
      ],
      dutyAccountData: [
        {
          region: '全国',
          province: '-',
          area: '-',
          accountName: '集中运营值班账号_鸿云',
          phone: '18521527010',
          owner: '',
          status: '有效',
        },
        {
          region: '华东',
          province: '上海',
          area: '上海-临港',
          accountName: 'IT值班账号_上海-临港数据中心1号楼',
          phone: '13671644874',
          owner: '',
          status: '有效',
        },
        {
          region: '华东',
          province: '上海',
          area: '上海-书院',
          accountName: 'IT值班账号_上海书院数据中心',
          phone: '15026518101',
          owner: '',
          status: '有效',
        },
        {
          region: '华南',
          province: '广东',
          area: '清远-清新',
          accountName: 'IT值班账号_清远-清新数据中心',
          phone: '18029753817',
          owner: '',
          status: '有效',
        },
        {
          region: '华北',
          province: '河北',
          area: '张家口-林东园',
          accountName: 'IT值班账号_张家口-林东园数据中心',
          phone: '18131343118',
          owner: '',
          status: '有效',
        },
        {
          region: '-',
          province: '-',
          area: '昆山千灯',
          accountName: 'IT值班账号_昆山千灯数据中心',
          phone: '18962449311',
          owner: '',
          status: '有效',
        },
        {
          region: '-',
          province: '-',
          area: '韶关-沐阳',
          accountName: 'IT值班账号_韶关-沐阳数据中心',
          phone: '15303063937',
          owner: '',
          status: '有效',
        },
        {
          region: '-',
          province: '-',
          area: '惠州-联丰',
          accountName: 'IT值班账号_惠州-联丰',
          phone: '13392003028',
          owner: '',
          status: '有效',
        },
      ],
    };
  },
  methods: {
    tableRowClassName({ rowIndex }) {
      return rowIndex % 2 === 0 ? 'even-row' : 'odd-row';
    },
    handleEdit(row) {
      console.log('编辑', row);
      // 在这里处理编辑操作
    },
    handleDelete(row) {
      console.log('删除', row);
      // 在这里处理删除操作
    },
    handleHistory(row) {
      console.log('历史记录', row);
      // 在这里处理历史记录操作
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.container {
  padding: 20px;
}
.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}
.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}
.box-card {
  margin-bottom: 20px;
}

::v-deep .el-table {
  th.el-table__cell {
    background-color: #4e71be !important;
    border: 0.5px solid #fff;
    .cell {
      white-space: pre-line;
      line-height: 1.5;
      color: #fff;
    }
  }
  th.el-table__cell:first-child {
    border: 0.5px solid #fff;
  }
  .el-table__header {
    border-color: #fff;
  }
  td.el-table__cell {
    border: 0.5px solid #fff;
    .cell {
      white-space: pre-line;
      line-height: 1.5;
    }
  }
  td.el-table__cell:first-child {
    background-color: #4e71be !important;
    color: #fff;
  }
  tr:hover > td.el-table__cell:first-child {
    background-color: #4e71be !important;
  }
}

::v-deep .el-table .even-row {
  background-color: #ced4e8;
}

::v-deep .el-table .odd-row {
  background-color: #e9ebf3;
}
::v-deep .el-table td.el-table__cell .cell {
  white-space: normal !important;
}
</style>